// For Firebase JS SDK v7.20.0 and later, measurementId is optional
export const firebaseConfig = {
    apiKey: "AIzaSyDsQc45FZ_FDN4aLbXBcYxb0M5LZgmD-wE",
    authDomain: "contents-site.firebaseapp.com",
    projectId: "contents-site",
    storageBucket: "contents-site.appspot.com",
    messagingSenderId: "525810286278",
    appId: "1:525810286278:web:18c788a21eaff5ae1921c7",
    measurementId: "G-5QM0K7YC7S"
  };